export function formatDate (date, fmt) {
     date =new Date(date)

    return  date.getUTCFullYear() +"-"+date.getMonth()+"-"+date.getDate() +"  "+date.getHours() +":"+date.getMinutes()+":"+date.getSeconds()

};

function padLeftZero (str) {
    return ('00' + str).substr(str.length);
};